import { Component, HostListener, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService, EventEmitterService } from 'src/app/shared/services';

@Component({
  selector: 'app-design-history',
  templateUrl: './design-history.component.html',
  styleUrls: ['./design-history.component.less']
})
export class DesignHistoryComponent implements OnInit {
@Input() designHistoryList:any[]=[];
@Input() isHandset:boolean;
@Input() roomId:any;
@Input() total:number=0; 
isFetched = false;
   imageResponse: any[] = [];
   currentRoomId: any;
   statusList: any[] = [];
   timePeriodList: any[] = [];
   designerList: any[] = [];
   timePeriod: any = "";
   status: any = []; //'01','02','03' ['New','Active'];
   designerid: any = ""; 
   curPage: number = 1;
   innerWidth: number; 
   authValue: any;
   showDropdown: boolean;
   userType: string;
   @ViewChild('notifyTemp') notifyTemp: TemplateRef<any>
   currentRowRoomId: any;
   currentDesignerValue: any;
   currentClientName: string;
   currentRowData: any;
   currentIndex: any;
   originalDesignerList = [];
   isLoading = false;
   page: number = 0;
   stageList: any[]=[];

  MILESTONE_UI: any = {
    intro_delivery: {
      label: 'Awaiting Designer Intro',
      bg: '#FFE1C8',
      color: '#5C3A1E',
      action: 'intro-sent'
    },
    idea_board_delivery: {
      label: 'Awaiting Idea Board',
      bg: '#FFF6BF',
      color: '#5C5C5C',
      action: 'idea-published'
    },
    idea_board_review: {
      label: 'Reviewing Idea Board',
      bg: '#FFE97F',
      color: '#2E2E2E',
      action: 'idea-approved'
    },
    concept_board_delivery: {
      label: 'Awaiting Concept Board',
      bg: '#D6E4FF',
      color: '#0C1C31',
      action: 'concept-published'
    },
    concept_board_review: {
      label: 'Reviewing Concept Board',
      bg: '#AFCBFF',
      color: '#0C1C31',
      action: 'concept-approved'
    },
    '3D_design_delivery': {
      label: 'Awaiting Final Design',
      bg: '#C8F5D4',
      color: '#1B3D2F',
      action: '3d-published'
    },
    '3D_design_review': {
      label: 'Reviewing Final Design',
      bg: '#afecff',
      color: '#0C1C31',
      action: '3d-approved'
    },
  };
 
   constructor(
     private api: ApiService,
     private matDialog: MatDialog,
     private snackbar: MatSnackBar,
     private router: Router,
     private route: ActivatedRoute,
     private eventEmitterService: EventEmitterService,
     private snackBar: MatSnackBar, 
   ) {
    
     this.isLoading = true;
     this.userType = JSON.parse(localStorage.getItem("user")).authorization;
 
   }
 
   get allowUser() {
     return ('' + this.userType).includes('9')
   }

     getMilestoneUI(type: string) {
    if (!type) return { bg: '#ffffff', color: '#333' }; // Default gray for empty

    const key = type;
    const ui = this.MILESTONE_UI[key];

    // if (!ui) {
    //   console.warn(`Mapping missing for: ${key}`);
    //   return { bg: 'red', color: 'white' }; // Red alert if key is missing!
    // }

    return ui;
  }
 
   @HostListener("window:resize")
   onResize() {
     this.innerWidth = window.innerWidth;
   }
 
 
 
   ngOnInit() {
     this.innerWidth = window.innerWidth;
     this.getDesignStatus();
     if (
       (
         JSON.parse(localStorage.getItem("user")) &&
         JSON.parse(localStorage.getItem("user")).email &&
         JSON.parse(localStorage.getItem("user")).email
       ).length > 0
     ) {
       this.getAuth();
 
     } else {
       this.router.navigate(["/"]);
     }
     this.eventEmitterService.userChangeEvent.asObservable().subscribe((res) => {
       if (
         (
           JSON.parse(localStorage.getItem("user")) &&
           JSON.parse(localStorage.getItem("user")).email &&
           JSON.parse(localStorage.getItem("user")).email
         ).length > 0
       ) {
         this.getAuth();
 
       } else {
         this.router.navigate(["/"]);
       }
     });
   }
 
 
   getDesignStausList(){
     this.api.getDesignStausList().subscribe((resp: any) => {
       this.statusList = resp.room_status;
       this.stageList = resp.room_stage?.sort((a,b)=>(a.serial - b.serial));
     });
   }
   assignBackStatusDesigner() {
 
     this.route.queryParamMap.subscribe(params => {
       const statusParam = params.get('status');
       const designerIdParam = params.get('designerid');
       const pageParam = params.get('page');
       this.page = pageParam ? parseInt(pageParam, 10) : 0;
       this.curPage = this.page;
       this.page = this.page > 0 ? this.page - 1 : 0;
       if (statusParam) {
         const codes = statusParam.split(',');
         this.status = this.statusList.filter(s => codes.includes(s.code)).map(m => m.code);
       }
 
       if (designerIdParam) {
         this.designerid = this.designerList.find(d => d.designerId === designerIdParam)?.designerId;
 
       }
     });
   }
 
 
   getAuth() {
     this.authValue = (JSON.parse(localStorage.getItem("user")).authorization);
     if (this.authValue == 90) {
       this.showDropdown = true;
     } else {
       this.showDropdown = false
     }
   }
   getDesignerName() {
     this.api.getDesignProfile().subscribe((res) => {
       this.designerList = res;
       this.originalDesignerList = JSON.parse(JSON.stringify(res))
       this.designerList.unshift({ designerId: '', first_name: '', last_name: '' })
       this.assignBackStatusDesigner();
       this.getDesignBookings();
 
 
     });
   }
 
   updateQueryParams() {
     const statusValues = this.status.join(',');
     const designerId = this.designerid;
     const currentParams = { ...this.route.snapshot.queryParams };
 
     if (statusValues) currentParams['status'] = statusValues;
     else delete currentParams['status'];
 
     if (designerId) currentParams['designerid'] = designerId;
     else delete currentParams['designerid'];
 
     if (this.page >= 0) currentParams['page'] = this.page + 1;
     else delete currentParams['page'];
 
     this.router.navigate([], {
       relativeTo: this.route,
       queryParams: currentParams,
     });
   }
 
   pageChanged(event) {
     this.curPage = event;
     this.page = event - 1;
     this.getDesignBookings();
   }
 
 
   getDesignBookings() {
        this.designHistoryList.forEach((f) => {
           f.isEdit = false;
           f.copyIcon = false;
           f.emailIcon = false;
           f.editDesigner = false;
           f.triggerEmailIcon = false;
           f.editStatus = false;
           f.editStage = false; 
           f.orderList = f.order_ids ? f.order_ids.split(',') : [];
           if (f.orderList.length > 1) {
             f.orderList.unshift('');
           }
           f.schedule = this.getPstTime(f.schedule_date);
           f.roomval = this.api.getRoomValue(f.room);
           f.stageVal = this.stageList?.find(s=>s.code===f.stage);
           f.stageData =this.stageList?.find(s=>s.code===f.stage)?.label;
         }); 
         setTimeout(() => {
    this.isLoading = false;
    this.isFetched = true;
          
         },100);
   }
   sendMail(roomId) {
     this.api.sendMailDesigner(roomId).subscribe((res: any) => {
       if (res && res.status) {
         this.snackBar.open('Mail sent successfully', 'x', {
           duration: 2000,
         })
         this.matDialog.closeAll();
       } else {
         this.snackBar.open('Mail not sent', 'x', {
           duration: 2000,
         })
       }
     }, err => {
       this.snackBar.open('Mail not sent', 'x', {
         duration: 2000,
       })
     })
   }
   showDesigner(i) {
     this.designHistoryList[i].editDesigner = true;
   }
   showStatus(i) {
     this.designHistoryList[i].editStatus = true;
   }
   showStage(i) {
     this.designHistoryList[i].editStage = true;
   }
 
   getStatus(s) {
     if (this.statusList.length > 0) {
       return this.statusList?.find(f => f.code === s)?.label;
     }
     return '';
   }
   getDesigner(s) {
     if (this.designerList.length > 0) {
       const dat = this.designerList?.find(f => (f.designerId) === (s.designer_assigned)); 
       if (dat) {
         return dat.first_name + ' ' + dat.last_name;
       } else {
         return '';
 
       }
     }
     return '';
   }
   getName(name: string): string {
     return name?.replace(/([A-Z])/g, ' $1').trim();
   }
 
   callUpdateAPI(callMail = false) {
     const data = { "room_id": this.currentRowRoomId, "designer_assigned": this.currentDesignerValue }
     this.api.updateAssignedDesigner(data).subscribe(res => {
       if (res) {
         this.designHistoryList[this.currentIndex].editDesigner = false;
 
         this.snackBar.open('Designer Updated Successfully', 'x', {
           duration: 2000,
         })
         if (this.currentDesignerValue && callMail) {
           this.sendMail(this.currentRowRoomId);
           this.designHistoryList[this.currentIndex].editDesigner = false;
         }
       } else {
         this.snackBar.open('Api error', 'x', {
           duration: 2000,
         })
       }
     }, err => {
       this.snackBar.open('Api error', 'x', {
         duration: 2000,
       })
     })
   }
   closeDialog() {
     this.matDialog.closeAll();
   }
 
   updateDesigner(s, event, i) {
     this.currentRowData = s;
     this.currentIndex = i;
     this.currentRowRoomId = s.room_id;
     this.currentDesignerValue = event.target.value;
     this.currentClientName = s.firstName ? s.firstName : 'this room';
     if (this.currentDesignerValue == '') {
       this.callUpdateAPI();
     } else {
       this.matDialog.open(this.notifyTemp, {
         width: '450px',
         disableClose: true
       }).afterClosed().subscribe(result => {
         if (result) {
           this.callUpdateAPI();
         }
       });
     }
 
   }
 
   showCopy(i) {
     // const index = ((this.curPage - 1) * 20) + i;
 
     this.designHistoryList.forEach(f => f.copyIcon = false);
     if(this.designHistoryList[i]){
     this.designHistoryList[i].copyIcon = true;
     }
   }
   hideCopy(i) {
     const index =i;// ((this.curPage - 1) * 20) + i;
     if(this.designHistoryList[index]){
 
     this.designHistoryList[index].copyIcon = false;
     }
   }
 
 
   showEmail(i) {
     
     // const index = ((this.curPage - 1) * 20) + i;
     this.designHistoryList.forEach(f => { f.emailIcon = false; f.triggerEmailIcon = false });
     if(this.designHistoryList[i]){
     this.designHistoryList[i].emailIcon = true;
     this.designHistoryList[i].triggerEmailIcon = true;
     }
   }
   hideEmail(i) {
     // const index = ((this.curPage - 1) * 20) + i;
     if(this.designHistoryList[i]){
 
     this.designHistoryList[i].emailIcon = false;
     this.designHistoryList[i].triggerEmailIcon = false;
     }
   }
   copyToClipboard(text) {
     if (navigator.clipboard) {
       navigator.clipboard
         .writeText(text)
         .then(() => {
           console.log("Text copied to clipboard");
         })
         .catch((err) => {
           console.error("Could not copy text: ", err);
         });
     } else {
       // Fallback for browsers that do not support Clipboard API
       // this.fallbackCopyTextToClipboard(text);
     }
   }
 
   getPstTime(date: any) {
     let dateObj: Date = typeof date == "string" ? new Date(date) : date;
     if (dateObj) {
       let offset = 7 * 60 * 60 * 1000;
       dateObj.setTime(dateObj.getTime() - offset);
       return dateObj;
     }
   }
 
   getDesignStatus() {
     this.api.getDesignStausList().subscribe((resp: any) => {
       this.statusList = resp.room_status;
          this.stageList = resp.room_stage?.sort((a,b)=>(a.serial - b.serial));
 
 
       this.getDesignerName();
 
     });
   }
 
   clearStatus() {
     this.status = [];
     this.getDesignBookings();
     this.curPage = 1;
 
   }
 
   onStatusChange() {
     this.page = 0;
     this.getDesignBookings();
   } 
 
   schedule() {
     let payload = {
       room_id: "",
     };
     this.api.sendDesignBookingMail(payload).subscribe((res) => {
       this.snackbar.open("Mail scheduled successfully", "x");
       this.getDesignBookings();
     });
   }
 
   ngAfterViewInit(): void {
     this.hideIntercomIcon();
   }
 
   hideIntercomIcon() {
     const interval = setInterval(() => {
       const intercom = document.getElementsByClassName(
         "intercom-lightweight-app"
       )[0];
       if (intercom) {
         intercom.classList.add("dn");
         clearInterval(interval);
       }
     }, 500);
 
     const intervalx = setInterval(() => {
       const intercomx = document.getElementsByClassName("intercom-app")[0];
       if (intercomx) {
         intercomx.classList.add("dn");
         clearInterval(intervalx);
       }
     }, 500);
   }
 
   goToPage(page) {
     if (page === -1) {
       this.curPage = Math.ceil(this.designHistoryList.length / 10);
     } else {
       this.curPage = page;
     }
 
   }
 
   get isLastPage() {
     return this.curPage === Math.floor(this.designHistoryList.length / 10);
   } 
 
   getColor(order) {
     const orderCode = this.statusList.filter(
       (val) => val.code === order.status
     )[0];
     if (orderCode) {
       return {
         "background-color": orderCode.bg_hex,
         color: orderCode.font_hex, //'white',
         padding: "6px 5px 3px 5px",
         "border-radius": "8px",
       };
     }
   }
 
 
   goToIntake(s) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`admin/dashboard/design/rooms/${s.room_id}/profile`]);
    });
   }
   openOrder(s) {
     if (s) {
       this.router.navigate([]).then(() => {
         window.open(`admin/dashboard/orders/${s}/summary`);
       });
 
     }
   }
 }
 